const NextIcon = () => {
  return (
    <svg width="10" height="13" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.49984 5L0.666504 1.16667L1.83317 0L6.83317 5L1.83317 10L0.666504 8.83333L4.49984 5Z"
        fill="#6E6E6E"
      />
    </svg>
  );
};

export default NextIcon;
